import React from 'react';
import RepayLoan1Component from '../components/repay-loan1';

const RepayLoan1 = () => {
  return (
    <div className="repay-loan-wrapper">
      <RepayLoan1Component />
    </div>
  );
};

export default RepayLoan1;
